import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/chalidabu/'
      className='link footer__link'
    >
      Chalid Abu Bakar @ 2024
    </a>
  </footer>
)

export default Footer
